import React from 'react';
import privacyPolicyBlocksEn from '../content/privacyPolicyBlocks';
import privacyPolicyBlocksId from '../content/privacyPolicyBlocks.id';
import LegalTextPage from './LegalTextPage';

const PrivacyPolicy = () => {
    return (
        <LegalTextPage
            blocksByLocale={{
                id: privacyPolicyBlocksId,
                en: privacyPolicyBlocksEn
            }}
            noticeByLocale={{
                id: 'Versi Indonesia adalah terjemahan 1:1 dari versi English.',
                en: 'The Indonesian version is a 1:1 translation of the English version.'
            }}
        />
    );
};

export default PrivacyPolicy;
